/**
 * Contains the logic for the sidebar.
 * @param graph the graph that belongs to these controls
 * @returns {{}}
 * 
 * 
 * Параметры визуальной настройки в объекте "slideBar" 
 * 	
 "slideBar": {
	  //Настройка для страницы "Детализация по элементу"
		"details": {
			//Показывать свойства
			"show": ["URI"],
			//Скрыть свойства
			"hide": ["name","type"]
		}
	},
 * 
 */
export default (graph) => {
	
	var sidebar = {},
		languageTools = webvowl.util.languageTools(),
		elementTools = webvowl.util.elementTools(),
	// Required for reloading when the language changes
		ontologyInfo,
    visibleSidebar=1,
		slideBarSettings = {},
		lastSelectedElement,

		detailArea     = d3.select("#detailsArea"),
		graphArea      = d3.select("#canvasArea"),
		menuArea       = d3.select("#swipeBarContainer"),
		collapseButton = d3.select("#sidebarExpandButton");
	/**
	 * Setup the menu bar.
	 */

    sidebar.updateArea = function (refs) {
	    detailArea     = d3.select(refs.detailsArea.current);
	    graphArea      = d3.select(refs.canvasArea.current);
	    menuArea       = d3.select(refs.swipeBarContainer.current);
	    collapseButton = d3.select(refs.sidebarExpandButton.current);
    };

	function setupCollapsing() {
		// adapted version of this example: http://www.normansblog.de/simple-jquery-accordion/
		function collapseContainers(containers) {
			containers.classed("hidden", true);
		}

		function expandContainers(containers) {
			containers.classed("hidden", false);
		}

		var triggers = d3.selectAll(".accordion-trigger");

		// Collapse all inactive triggers on startup
		collapseContainers(d3.selectAll(".accordion-trigger:not(.accordion-trigger-active) + div"));

		triggers.on("click", function () {
			var selectedTrigger = d3.select(this),
				activeTriggers = d3.selectAll(".accordion-trigger-active");

			if (selectedTrigger.classed("accordion-trigger-active")) {
				// Collapse the active (which is also the selected) trigger
				collapseContainers(d3.select(selectedTrigger.node().nextElementSibling));
				selectedTrigger.classed("accordion-trigger-active", false);
			} else {
				// Collapse the other trigger ...
				collapseContainers(d3.selectAll(".accordion-trigger-active + div"));
				activeTriggers.classed("accordion-trigger-active", false);
				// ... and expand the selected one
				expandContainers(d3.select(selectedTrigger.node().nextElementSibling));
				selectedTrigger.classed("accordion-trigger-active", true);
			}
		});
	}

	sidebar.clearOntologyInformation= function(){
		const i18n = graph.i18n();
		d3.select("#title").text(i18n?i18n.t('graph.sidebar.noTitle'):"No title available");
		d3.select("#about").attr("href", "#").attr("target", "_blank").text(i18n?i18n.t('graph.sidebar.notGiven'):"not given"); //not given
		d3.select("#version").text("--");
		d3.select("#authors").text("--");
		d3.select("#description").text(i18n?i18n.t('graph.sidebar.noDescription'):"No description available.");
		var container = d3.select("#ontology-metadata");
		container.selectAll("*").remove();
		d3.select("#classCount")
			.text("0");
		d3.select("#subClassCount")
			.text("0");			
		d3.select("#typesCount")
			.text("");						
		d3.select("#legendCount")
			.text("");									
		d3.select("#objectPropertyCount")
			.text("0");
		d3.select("#datatypePropertyCount")
			.text("0");
		d3.select("#individualCount")
			.text("0");
		d3.select("#nodeCount")
			.text("0");
		d3.select("#edgeCount")
			.text("0");

		// clear selectedNode info
		// console.log('sparqlSidebar.js d3.select("#selection-details-trigger")'); console.log(d3.select("#selection-details-trigger"));
		// if (d3.select("#selection-details-trigger")){
		// 	var isTriggerActive = d3.select("#selection-details-trigger").classed("accordion-trigger-active");
		// 	if (isTriggerActive){
		// 		// close accordion
		// 		d3.select("#selection-details-trigger").node().click();
		// 	}	
		// }
		// showSelectionAdvice();
	};

	/**
	 * Updates the information of the passed ontology.
	 * @param data the graph data
	 * @param statistics the statistics module
	 */
	sidebar.updateOntologyInformation = function (helper, statistics) {
		ontologyInfo = (helper)? helper.getHeader() || {}: {};
		slideBarSettings = (helper)? helper.getSlideBarSettings() || {}: {};
		//console.log("sparqlSidebar.js updateOntologyInformation", helper, statistics, ontologyInfo);

		updateGraphInformation();
		sidebar.displayGraphStatistics(undefined, statistics);
		displayMetadata(ontologyInfo.other);
		displayLegend(ontologyInfo);
		// Reset the sidebar selection
		sidebar.updateSelectionInformation(undefined);

		setLanguages(ontologyInfo.languages, ontologyInfo.defaultLanguage);
	};

	function setLanguages(languages, defaultLanguage=undefined) {
		languages = languages || [];

		// Put the default and unset label on top of the selection labels
		languages.sort(function (a, b) {
			if (defaultLanguage){
				if (a === defaultLanguage) return -1;
				if (b === defaultLanguage) return 1;
			}
			if (a === webvowl.util.constants().LANG_IRIBASED) {
				return -1;
			} else if (b === webvowl.util.constants().LANG_IRIBASED) {
				return 1;
			}
			if (a === webvowl.util.constants().LANG_UNDEFINED) {
				return -1;
			} else if (b === webvowl.util.constants().LANG_UNDEFINED) {
				return 1;
			}
			return a.localeCompare(b);
		});

		var languageSelection = d3.select("#language")
			.on("change", function () {
				graph.language(d3.event.target.value);
				updateGraphInformation();
				sidebar.updateSelectionInformation(lastSelectedElement);
			});

		languageSelection.selectAll("option").remove();
		languageSelection.selectAll("option")
			.data(languages)
			.enter().append("option")
			.attr("value", function (d) {
				return d;
			})
			.text(function (d) {
				return d;
			});

		//Попробуем установить язык, который задан по умолчанию
		if (defaultLanguage)
			if(trySelectDefaultLanguage(languageSelection, languages, defaultLanguage)) return;
		
		if (!trySelectDefaultLanguage(languageSelection, languages, "en")) {
			if (!trySelectDefaultLanguage(languageSelection, languages, webvowl.util.constants().LANG_UNDEFINED)) {
				trySelectDefaultLanguage(languageSelection, languages, webvowl.util.constants().LANG_IRIBASED);
			}
		}
	}

	function trySelectDefaultLanguage(selection, languages, language) {
		var langIndex = languages.indexOf(language);
		if (langIndex >= 0) {
			selection.property("selectedIndex", langIndex);
			graph.language(language);
			return true;
		}

		return false;
	}

	function updateGraphInformation() {
		const i18n = graph.i18n();
		var title = languageTools.textInLanguage(ontologyInfo.title, graph.language());
		//console.log("sparqlSidebar.js", "updateGraphInformation", ontologyInfo);
		d3.select("#title").text(title || (i18n?i18n.t('graph.sidebar.noTitle'):"No title available")); 
		d3.select("#about").attr("href", ontologyInfo.iri).attr("target", "_blank").text(ontologyInfo.iri);
		d3.select("#version").text(ontologyInfo.version || "--");
		var authors = ontologyInfo.author;
		if (typeof authors === "string") {
			// Stay compatible with author info as strings after change in january 2015
			d3.select("#authors").text(authors);
		} else if (authors instanceof Array) {
			d3.select("#authors").text(authors.join(", "));
		} else {
			d3.select("#authors").text("--");
		}

		var description = languageTools.textInLanguage(ontologyInfo.description, graph.language());
		d3.select("#description").text(description || (i18n?i18n.t('graph.sidebar.noDescription'):"No description available"));
	}

	sidebar.displayGraphStatistics = function (deliveredMetrics, statistics) {
		const i18n = graph.i18n();
		// Metrics are optional and may be undefined
		deliveredMetrics = deliveredMetrics || {};
		const unfilteredData = graph.getUnfilteredData();
		const allNodesCount = (unfilteredData && unfilteredData.nodes)? unfilteredData.nodes.length: 0;
		const allEdgesCount = (unfilteredData && unfilteredData.properties)? unfilteredData.properties.length: 0;
		d3.select("#classCount")
			.text(deliveredMetrics.classCount || statistics.classCountAdv(i18n));
		d3.select("#subClassCount")
			.text(deliveredMetrics.totalSubClasses || statistics.totalSubClasses());
		d3.select("#typesCount")
			.text(deliveredMetrics.typesCount || statistics.typesCount((ontologyInfo)?ontologyInfo.prefixList:undefined));
		d3.select("#objectPropertyCount")
			.text(deliveredMetrics.objectPropertyCount || statistics.objectPropertyCount());
		d3.select("#datatypePropertyCount")
			.text(deliveredMetrics.datatypePropertyCount || statistics.datatypePropertyCount());
		d3.select("#individualCount")
			.text(deliveredMetrics.totalIndividualCount || statistics.totalIndividualCount());
		
		if (allNodesCount<=statistics.nodeCount())
			d3.select("#nodeCount")
				.text(statistics.nodeCount());
		else
			d3.select("#nodeCount")
				.text(statistics.nodeCount() +" ("+(i18n?i18n.t('graph.statistic.nodeOf'):"of") +" "+allNodesCount+")");
		d3.select("#legendCount")
			.text(deliveredMetrics.legendCount || statistics.legendNodesCount((ontologyInfo)?ontologyInfo.statNodes:undefined, i18n));

		if (allEdgesCount<=statistics.edgeCount())
			d3.select("#edgeCount")
				.text(statistics.edgeCount());
		else
			d3.select("#edgeCount")
				.text(statistics.edgeCount() +" ("+(i18n?i18n.t('graph.statistic.edgeOf'):"of") +" "+allEdgesCount+")");
		d3.select("#legendEdgesCount")
			.text(deliveredMetrics.legendCount || statistics.legendEdgesCount((ontologyInfo)?ontologyInfo.statEdges:undefined, i18n));

	}

	function displayMetadata(metadata) {
		const i18n = graph.i18n();
		var container = d3.select("#ontology-metadata");
		container.selectAll("*").remove();

		listAnnotations(container, metadata);

		if (container.selectAll(".annotation").size() <= 0) {
			container.append("p").text(i18n?i18n.t('graph.sidebar.noAnnatations'):"No annotations available");
		}
	}


	function displayLegend(ontology){
		if (ontology.hasOwnProperty("legend")){
			 d3.select("#selection-legend-trigger")
			 	.style("display","block");
			 d3.select("#selection-legend")
			  .style("display","block");
			 d3.select("#legendContent")
			   .html(ontology["legend"])
		} else {
			d3.select("#selection-legend-trigger").style("display","none");
			d3.select("#selection-legend").style("display","none");
		}
	}
	/** Заполнение литеральных свойств в секции Детализация по элементу  */
	function listAnnotations(container, annotationObject) {
		annotationObject = annotationObject || {};  //todo

		// Collect the annotations in an array for simpler processing
		var annotations = [];
		for (var annotation in annotationObject) {
			if (annotationObject.hasOwnProperty(annotation)) {
				//Игнорировать коллективную работу в аннотации
				if (annotation=="teamwork") continue;
				//Скрыть отображение заданых в настроках узлов
				if (slideBarSettings.details && Array.isArray(slideBarSettings.details.hide) 
					&& slideBarSettings.details.hide.indexOf(annotation)>-1)
					  continue;

				const value = annotationObject[annotation];
				if (!Array.isArray(value))
					annotations.push(value);
				else {
					if (value.length != 0)
						annotations.push(value[0]);
				}
				//Надо посмотреть, что это массив значений и создать список элементов 
				if (Array.isArray(value) && value.length>1){
					//Заполним либо по выбранному языку, либо все 
					//иначе могут дубиловаться значения из-за одного итого же, но с разным кодом языка)
					const langValues = value.filter(item => item.language == graph.language());
					value[0].values = (langValues.length>0)
						? langValues.map(item =>  ({type: item.type, value:item.value, language : item.language}))
						: value.map(item =>  ({type: item.type, value:item.value, language : item.language}));
				}
			}
		}
		//console.log("sparqlSidebar.js listAnnotations", annotationObject, annotations, graph.language());
		container.selectAll(".annotation").remove();
		container.selectAll(".annotation").data(annotations).enter().append("p")
			.classed("annotation", true)
			.classed("propDetails", true)
			.text(function (d) {
				return d.identifier + ":";
			})
			.append("span")
			.each(function (d) {
				//Тут есть много значений в описании свойства
				if (d.hasOwnProperty("values")){
					appendListText(d3.select(this), d.values);
				} else {
					if (d.value && d.value.indexOf("<p>")>-1)
						appendHTMLText(d3.select(this), d.value);
					else
						appendIriLabel(d3.select(this), d.value, d.type === "iri" ? d.value : undefined);
				}
			});
	}

	/**
	 * Update the information of the selected node.
	 * @param selectedElement the selection or null if nothing is selected
	 */
	sidebar.updateSelectionInformation = function (selectedElement) {
		//if (selectedElement) console.log("sparqlSidebar.js updateSelectionInformation", selectedElement.iri(), isTriggerActive, selectedElement)
		lastSelectedElement = selectedElement;

		// Click event was prevented when dragging
		if (d3.event && d3.event.defaultPrevented) {
			return;
		}

		var isTriggerActive = d3.select("#selection-details-trigger").classed("accordion-trigger-active");
		if (selectedElement && !isTriggerActive) {
			d3.select("#selection-details-trigger").node().click();
		} else if (!selectedElement && isTriggerActive) {
			showSelectionAdvice();
			return;
		}

		if (elementTools.isProperty(selectedElement)) {
			displayPropertyInformation(selectedElement);
		} else if (elementTools.isNode(selectedElement)) {
			displayNodeInformation(selectedElement);
		}
	};

	function showSelectionAdvice() {
		setSelectionInformationVisibility(false, false, true);
	}

	function setSelectionInformationVisibility(showClasses, showProperties, showAdvice) {
		d3.select("#classSelectionInformation").classed("hidden", !showClasses);
		d3.select("#propertySelectionInformation").classed("hidden", !showProperties);
		d3.select("#noSelectionInformation").classed("hidden", !showAdvice);
		//Информация о коллективной работа
		d3.select("#noTeamworksInformation").classed("hidden", !showAdvice);
		d3.select("#teamworksInformation").classed("hidden", showAdvice);
	}

	function displayPropertyInformation(property) {
		showPropertyInformations();

		setIriLabel(d3.select("#propname"), property.labelForCurrentLanguage(), property.iri());
		d3.select("#typeProp").text(property.type());

		if (property.inverse() !== undefined) {
			d3.select("#inverse").classed("hidden", false);
			setIriLabel(d3.select("#inverse span"), property.inverse().labelForCurrentLanguage(), property.inverse().iri());
		} else {
			d3.select("#inverse").classed("hidden", true);
		}

		var equivalentIriSpan = d3.select("#propEquivUri");
		listNodeArray(equivalentIriSpan, property.equivalents());

		listNodeArray(d3.select("#subproperties"), property.subproperties());
		listNodeArray(d3.select("#superproperties"), property.superproperties());

		if (property.minCardinality() !== undefined) {
			d3.select("#infoCardinality").classed("hidden", true);
			d3.select("#minCardinality").classed("hidden", false);
			d3.select("#minCardinality span").text(property.minCardinality());
			d3.select("#maxCardinality").classed("hidden", false);

			if (property.maxCardinality() !== undefined) {
				d3.select("#maxCardinality span").text(property.maxCardinality());
			} else {
				d3.select("#maxCardinality span").text("*");
			}

		} else if (property.cardinality() !== undefined) {
			d3.select("#minCardinality").classed("hidden", true);
			d3.select("#maxCardinality").classed("hidden", true);
			d3.select("#infoCardinality").classed("hidden", false);
			d3.select("#infoCardinality span").text(property.cardinality());
		} else {
			d3.select("#infoCardinality").classed("hidden", true);
			d3.select("#minCardinality").classed("hidden", true);
			d3.select("#maxCardinality").classed("hidden", true);
		}

		setIriLabel(d3.select("#domain"), property.domain().labelForCurrentLanguage(), property.domain().iri());
		setIriLabel(d3.select("#range"), property.range().labelForCurrentLanguage(), property.range().iri());

		displayAttributes(property.attributes(), d3.select("#propAttributes"));

		setTextAndVisibility(d3.select("#propDescription"), property.descriptionForCurrentLanguage());
		setTextAndVisibility(d3.select("#propComment"), property.commentForCurrentLanguage());

		listAnnotations(d3.select("#propertySelectionInformation"), property.annotations());
	}

	function showPropertyInformations() {
		setSelectionInformationVisibility(false, true, false);
	}

	function setIriLabel(element, name, iri) {
		var parent = d3.select(element.node().parentNode);

		if (name) {
			element.selectAll("*").remove();
			appendIriLabel(element, name, iri);
			parent.classed("hidden", false);
		} else {
			parent.classed("hidden", true);
		}
	}


	/** Специальный обработчик списка строк */
  function appendListText(element, values){
		for (let index = 0; index < values.length; index++) {
			const item = values[index];
			if (item.value && item.value.indexOf("<p>")>-1){
				const text = item.value + ((index<values.length-1)? ", ":"");
				element
					.append("span")
					.style("font-size","0.9em")
					.style("font-weight","300")
					.html(text);	
			} else {
				const text = item.value + ((index<values.length-1)? ", ":"");
				appendIriLabel(element, text, item.type === "iri" ? text : undefined);	
		  }			
		}
  }

	/** Специальный парсинг для строк, содержащих escape HTML entities */
  function appendHTMLText(element, text, emptyChildren = false){
		if (emptyChildren)
			element.selectAll("*").remove();
		//var doc = new DOMParser().parseFromString(text, "text/html");
		//return doc.documentElement.textContent;
		//см. https://www.tutorialsteacher.com/d3js/dom-manipulation-using-d3js
		element
			.append("span")
			.style("font-size","0.9em")
			.style("font-weight","300")
			.html(text);
	}

	function appendIriLabel(element, name, iri, emptyChildren = false) {
		var tag;

		if (emptyChildren)
			element.selectAll("*").remove();
		if (iri) {
			tag = element.append("a")
				.attr("href", iri)
				.attr("title", iri)
				.attr("target", "_blank");
		} else {
			tag = element.append("span");
		}
		tag.text(name);
	}

	function displayAttributes(attributes, textSpan) {
		var spanParent = d3.select(textSpan.node().parentNode);

		if (attributes && attributes.length > 0) {
			// Remove redundant redundant attributes for sidebar
			removeElementFromArray("object", attributes);
			removeElementFromArray("datatype", attributes);
			removeElementFromArray("rdf", attributes);
		}

		if (attributes && attributes.length > 0) {
			textSpan.text(attributes.join(", "));

			spanParent.classed("hidden", false);
		} else {
			spanParent.classed("hidden", true);
		}
	}

	function removeElementFromArray(element, array) {
		var index = array.indexOf(element);
		if (index > -1) {
			array.splice(index, 1);
		}
	}

	/**
	 * Публикация информации о выбранном узле -----------------------
	 */
	function displayNodeInformation(node) {
		showClassInformations();

		if (slideBarSettings.details && Array.isArray(slideBarSettings.details.show) 
			&& slideBarSettings.details.show.indexOf("URI")>-1){
				d3.select(d3.select("#uri").node().parentNode).classed("hidden", false);
				appendIriLabel(d3.select("#uri"), node.iri(), node.iri(), true);
		} else {
			d3.select(d3.select("#uri").node().parentNode).classed("hidden", true);
		}

		if (slideBarSettings.details && Array.isArray(slideBarSettings.details.hide) 
				&& slideBarSettings.details.hide.indexOf("name")>-1)
				d3.select(d3.select("#name").node().parentNode).classed("hidden", true);
		else {
			setIriLabel(d3.select("#name"), node.labelForCurrentLanguage(), node.iri());
			d3.select(d3.select("#name").node().parentNode).classed("hidden", false);
		}					

		/* Equivalent stuff. */
		var equivalentIriSpan = d3.select("#classEquivUri");
		listNodeArray(equivalentIriSpan, node.equivalents());

		d3.select("#typeNode").text(node.type());
		listNodeArray(d3.select("#individuals"), node.individuals());

		/* Disjoint stuff. */
		var disjointNodes = d3.select("#disjointNodes");
		var disjointNodesParent = d3.select(disjointNodes.node().parentNode);

		if (node.disjointWith() !== undefined) {
			disjointNodes.selectAll("*").remove();

			node.disjointWith().forEach(function (element, index) {
				if (index > 0) {
					disjointNodes.append("span").text(", ");
				}
				appendIriLabel(disjointNodes, element.labelForCurrentLanguage(), element.iri());
			});

			disjointNodesParent.classed("hidden", false);
		} else {
			disjointNodesParent.classed("hidden", true);
		}

		displayAttributes(node.attributes(), d3.select("#classAttributes"));

		setTextAndVisibility(d3.select("#nodeDescription"), node.descriptionForCurrentLanguage());
		setTextAndVisibility(d3.select("#nodeComment"), node.commentForCurrentLanguage());

		listAnnotations(d3.select("#classSelectionInformation"), node.annotations());

		showTeamworks(node);
	}

	//Публикация информации о коллективной работе
	function showTeamworks(node){
		//console.log("showTeamworks", node);
		let annotationObject = node.annotations() || {};  //todo

		let tasks = [];
		let requirements = [];
		if (annotationObject.hasOwnProperty("teamwork")) {
			let teamworks = annotationObject["teamwork"] || [];
			if (Array.isArray(teamworks)){
				tasks = teamworks.filter(tw => tw.annotations && tw.annotations.identifierToAnnotation && tw.annotations.identifierToAnnotation.task)
				requirements = teamworks.filter(tw => tw.annotations && tw.annotations.identifierToAnnotation && tw.annotations.identifierToAnnotation.implementedBy)
			}
		}

		d3.select("#noTeamworks").classed("hidden", (tasks.length>0)||(requirements.length>0));
		d3.select("#taskDetails").classed("hidden", tasks.length==0);
		d3.select("#requirementDetails").classed("hidden", requirements.length==0);
		

		//console.log("tasks", tasks);
		var container = d3.select("#tasks");
		container.selectAll(".task").remove();
		container.selectAll(".task").data(tasks).enter().append("p")
			.classed("task", true)
			.text(function (d) {
				if (d.annotations.labels&&Array.isArray(d.annotations.labels)&&(d.annotations.labels.length>0))
					return d.annotations.labels[0].value
				return d.identifier + ":";
			})
			.append("span")
			.each(function (d) {
				//appendIriLabel(d3.select(this), d.value, d.type === "iri" ? d.value : undefined);
			});
		//console.log("requirements", requirements);
		var container = d3.select("#requirements");
		container.selectAll(".requirement").remove();
		container.selectAll(".requirement").data(requirements).enter().append("p")
			.classed("requirement", true)
			.text(function (d) {
				//console.log("d", d);
				if (d.annotations.labels&&Array.isArray(d.annotations.labels)&&(d.annotations.labels.length>0))
					return d.annotations.labels[0].value
				return d.identifier + ":";
			})
			.append("span")
			.each(function (d) {
				//appendIriLabel(d3.select(this), d.value, d.type === "iri" ? d.value : undefined);
			});
	}

	/** Формирует строку для отборажения информации о коллективной работе  */
	function getTeamworkLink(annotations){

	}

	function showClassInformations() {
		setSelectionInformationVisibility(true, false, false);
	}

	function listNodeArray(textSpan, nodes) {
		var spanParent = d3.select(textSpan.node().parentNode);

		if (nodes && nodes.length) {
			textSpan.selectAll("*").remove();
			nodes.forEach(function (element, index) {
				if (index > 0) {
					textSpan.append("span").text(", ");
				}
				appendIriLabel(textSpan, element.labelForCurrentLanguage(), element.iri());
			});

			spanParent.classed("hidden", false);
		} else {
			spanParent.classed("hidden", true);
		}
	}

	function setTextAndVisibility(label, value) {
		var parentNode = d3.select(label.node().parentNode);
		var hasValue = !!value;
		if (value) {
			label.text(value);
		}
		parentNode.classed("hidden", !hasValue);
	}

	/** Collapsible Sidebar functions; **/

    sidebar.showSidebar=function(val,init){
        // make val to bool
        if (val===1) {
			visibleSidebar=true;
			detailArea.style.top =  graphArea.style.top;
            collapseButton.node().innerHTML=">";
            detailArea.classed("hidden",true);
            if (init===true) {
                detailArea.classed("hidden",!visibleSidebar);
                graphArea.style("width","78%");
                graphArea.style("-webkit-animation-name","none");

                menuArea.style("width","100%"); //78%
                menuArea.style("-webkit-animation-name","none");

                d3.select("#WarningErrorMessagesContainer").style("width","78%");
                d3.select("#WarningErrorMessagesContainer").style("-webkit-animation-name","none");
            } else {
                graphArea.style("width","78%");
                graphArea.style("-webkit-animation-name","sbCollapseAnimation");
                graphArea.style("-webkit-animation-duration","0.5s");

                menuArea.style("width","100%"); //78%
                menuArea.style("-webkit-animation-name","sbCollapseAnimation");
                menuArea.style("-webkit-animation-duration","0.5s");

                d3.select("#WarningErrorMessagesContainer").style("width","78%");
                d3.select("#WarningErrorMessagesContainer").style("-webkit-animation-name","warn_ExpandRightBarAnimation");
                d3.select("#WarningErrorMessagesContainer").style("-webkit-animation-duration","0.5s");
            }
            graph.options().width(window.innerWidth - (window.innerWidth * 0.22));
            graph.options().navigationMenu().updateScrollButtonVisibility();
        }
        if (val===0){
            visibleSidebar=false;
            detailArea.classed("hidden",true);

            collapseButton.node().innerHTML="<";
            // adjust the layout
            if (init===true) {
                graphArea.style("width","100%");
                graphArea.style("-webkit-animation-name","none");

                menuArea.style("width","100%");
                menuArea.style("-webkit-animation-name","none");

                d3.select("#WarningErrorMessagesContainer").style("width","100%");
                d3.select("#WarningErrorMessagesContainer").style("-webkit-animation-name","none");
            }else {
                graphArea.style("width","100%");
                graphArea.style("-webkit-animation-name","sbExpandAnimation");
                graphArea.style("-webkit-animation-duration","0.5s");

				menuArea.style("width","100%");
                menuArea.style("-webkit-animation-name","sbExpandAnimation");
                menuArea.style("-webkit-animation-duration","0.5s");

                d3.select("#WarningErrorMessagesContainer").style("width","100%");
                d3.select("#WarningErrorMessagesContainer").style("-webkit-animation-name","warn_CollapseRightBarAnimation");
                d3.select("#WarningErrorMessagesContainer").style("-webkit-animation-duration","0.5s");

            }
            graph.options().width(window.innerWidth);
            graph.updateCanvasContainerSize();
            graph.options().navigationMenu().updateScrollButtonVisibility();
        }
    };

    sidebar.isSidebarVisible=function(){return visibleSidebar;};

    sidebar.updateSideBarVis=function(init){
        var vis=sidebar.getSidebarVisibility();
        sidebar.showSidebar(parseInt(vis),init);
    };

    sidebar.getSidebarVisibility=function(){
        var isHidden=detailArea.classed("hidden");
        if (isHidden===false) return String(1);
        if (isHidden===true) return String(0);
	};

    sidebar.initSideBarAnimation=function(){
        graphArea.node().addEventListener("animationend", function() {
            detailArea.classed("hidden", !visibleSidebar);
            graph.updateCanvasContainerSize();
            graph.options().navigationMenu().updateScrollButtonVisibility();
        });
    };

    sidebar.setup = function (refs) {
			sidebar.updateArea(refs);
        setupCollapsing();
        sidebar.initSideBarAnimation();

        collapseButton.on("click",function(){
            graph.options().navigationMenu().hideAllMenus();
            var settingValue=parseInt(sidebar.getSidebarVisibility());
            if (settingValue===1) sidebar.showSidebar(0);
            else                  sidebar.showSidebar(1);
        });
    };


    sidebar.updateShowedInformation=function(){
		var editMode=graph.editorMode();
        d3.select("#generalDetails").classed("hidden",editMode);
        d3.select("#generalDetailsEdit").classed("hidden",!editMode);

        // store the meta information in graph.options()

		// todo: update edit meta info
        graph.options().editSidebar().updateGeneralOntologyInfo();

		// todo: update showed meta info;
        graph.options().sidebar().updateGeneralOntologyInfo();

	};

    sidebar.updateGeneralOntologyInfo=function() {
        // get it from graph.options
        var generalMetaObj = graph.options().getGeneralMetaObject();
		let preferredLanguage = graph && graph.language ? graph.language() : null;
        if (generalMetaObj.hasOwnProperty("title")) {
            if (typeof (generalMetaObj.title) === "object") {
                d3.select("#title").node().value = languageTools.textInLanguage(generalMetaObj.title, preferredLanguage);
            } else{
                d3.select("#title").node().innerHTML = generalMetaObj.title;
            }

         }
        if (generalMetaObj.hasOwnProperty("iri")) d3.select("#about").node().innerHTML= generalMetaObj.iri;
        if (generalMetaObj.hasOwnProperty("iri")) d3.select("#about").node().href= generalMetaObj.iri;
        if (generalMetaObj.hasOwnProperty("version")) d3.select("#version").node().innerHTML = generalMetaObj.version;
        if (generalMetaObj.hasOwnProperty("author")) d3.select("#authors").node().innerHTML = generalMetaObj.author;
 		// this could also be an object >>
        if (generalMetaObj.hasOwnProperty("description")) {
            if (typeof generalMetaObj.description === "object") {
                d3.select("#description").node().innerHTML = languageTools.textInLanguage(generalMetaObj.description, preferredLanguage);
            }
            else {
                d3.select("#description").node().innerHTML = generalMetaObj.description;
            }
        }
    };


        return sidebar;
};
